"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonInstaller = void 0;
const EventStreamEvents_1 = require("../EventStream/EventStreamEvents");
const IJsonInstaller_1 = require("./IJsonInstaller");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
class JsonInstaller extends IJsonInstaller_1.IJsonInstaller {
    constructor(eventStream, vscodeAccessor) {
        super(eventStream, vscodeAccessor);
        this.eventStream = eventStream;
        this.vscodeAccessor = vscodeAccessor;
        // If a new extension is installed, we want to install .NET preemptively for it if specified
        vscodeAccessor.registerOnExtensionChange(() => {
            this.eventStream.post(new EventStreamEvents_1.DotnetVSCodeExtensionChange(`A change was detected in the extensions. Installing .NET for new extensions.`));
            this.executeJSONRequests().catch(() => { });
        });
        // On startup, (our extension gets activated onStartupFinished() via 'activationEvents' in package.json) we want to install .NET preemptively
        // So other extensions can have a faster startup time if they so desire
        this.executeJSONRequests().catch(() => { });
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    executeJSONRequests() {
        return __awaiter(this, void 0, void 0, function* () {
            const extensions = this.vscodeAccessor.getExtensions();
            for (const extension of extensions) {
                const extensionPackage = extension === null || extension === void 0 ? void 0 : extension.packageJSON;
                this.eventStream.post(new EventStreamEvents_1.DotnetVSCodeExtensionFound(`Checking extension ${extension === null || extension === void 0 ? void 0 : extension.id} for .NET installation requests`));
                if (extensionPackage === null || extensionPackage === void 0 ? void 0 : extensionPackage['x-dotnet-acquire']) {
                    this.eventStream.post(new EventStreamEvents_1.DotnetVSCodeExtensionHasInstallRequest(`Installing .NET for extension ${extension.id}`));
                    const jsonRequest = extensionPackage["x-dotnet-acquire"];
                    const apiRequest = Object.assign(Object.assign({}, jsonRequest), { requestingExtensionId: extension.id });
                    this.vscodeAccessor.executeCommand('dotnet.acquire', apiRequest);
                }
            }
        });
    }
}
exports.JsonInstaller = JsonInstaller;
//# sourceMappingURL=JsonInstaller.js.map